<template>
  <section
    class="slot-panel rounded shadow-md p-4 relative venue-ui:bg-surface-primary"
    :class="classes"
  >
    <slot></slot>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SlotPanel',
  props: {
    classes: { type: String, required: false },
  },
})
</script>
